import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap'
import { I18nModule, provideConfig } from '@spartacus/core'
import { OutletModule, PageComponentModule } from '@spartacus/storefront'

import { EbBannerModule } from './banner/eb-banner.module'
import { EbCmsButtonComponent } from './cms-button/eb-cms-button.component'

import { EbDatePickerI18nService } from './date-picker/eb-date-picker-i18n.service'

import { EbMatomoModule } from './eb-matomo/eb-matomo.module'
import { EBResponsiveBannerModule } from './eb-reponsive-banner/eb-responsive-banner.module'
import { EBResponsiveHighlightModule } from './eb-responsive-highlight/eb-responsive-highlight.module'
import { EbTabParagraphContainerComponent } from './eb-tab-paragraph-container/eb-tab-paragraph-container.component'

import { EbGroupedFavoritesModule } from './grouped-favorites/eb-grouped-favorites.module'
import { EbIconModule } from './icons/eb-icon.module'
import { EbParagraphModule } from './paragraph/eb-paragraph.module'

import { EbUnitSelectorComponent } from './unit-selector/eb-unit-selector.component'

@NgModule({
  imports: [
    CommonModule,
    EbIconModule,
    EbBannerModule,
    EbGroupedFavoritesModule,
    EbCmsButtonComponent,
    PageComponentModule,
    OutletModule,
    I18nModule,
    EbMatomoModule,
    MatSlideToggleModule,
    MatFormFieldModule,
    EBResponsiveBannerModule,
    EBResponsiveHighlightModule,
    EbParagraphModule,
    EbTabParagraphContainerComponent,
    EbUnitSelectorComponent
  ],
  exports: [EbTabParagraphContainerComponent, EbUnitSelectorComponent],
  providers: [
    EbDatePickerI18nService,
    provideConfig({
      cmsComponents: {
        ButtonComponent: {
          component: EbCmsButtonComponent
        },
        CMSTabParagraphContainer: {
          component: EbTabParagraphContainerComponent
        },
        EbUnitSelectorComponent: {
          component: EbUnitSelectorComponent
        }
      }
    }),
    {
      provide: NgbDatepickerI18n,
      useClass: EbDatePickerI18nService
    }
  ]
})
export class EbComponentsModule {}
